export default "__VITE_ASSET__12a09629__"